import { render, staticRenderFns } from "./ReviewResponses.vue?vue&type=template&id=401e528a"
import script from "./ReviewResponses.vue?vue&type=script&lang=js"
export * from "./ReviewResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports